import styles from '@ui/components/Voting/components/Result/Result.module.scss';
import Heading from '@ui/components/Heading/Heading';
import ProgressBar from '@ui/components/Voting/components/ProgressBar/ProgressBar';
import React, { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import { nanoid } from 'nanoid';

const Result = ({ question, results, selectedIndex }) => {
  const id = useMemo(() => nanoid(), []);

  return (
    <div className={styles.container}>
      <Heading align="center" className={styles.question} id={id} size="h4">
        {question}
      </Heading>
      <dl aria-labelledby={id} className={styles.answerDescriptionList}>
        {results?.map(({ answer, percentage }, index) => (
          <Fragment key={`${question}-${answer}`}>
            <ProgressBar
              answer={answer}
              duration={20}
              selected={selectedIndex === index}
              value={percentage}
            />
          </Fragment>
        ))}
      </dl>
      <Heading as="p" className={styles.endMessage} size="h5">
        Vielen Dank für Ihr Feedback!
      </Heading>
    </div>
  );
};

Result.propTypes = {
  question: PropTypes.string.isRequired,
  results: PropTypes.arrayOf(
    PropTypes.shape({ answer: PropTypes.string, percentage: PropTypes.number }),
  ).isRequired,
  selectedIndex: PropTypes.number.isRequired,
};

export default Result;
